var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 0H1.33333C0.979711 0 0.640573 0.140476 0.390524 0.390524C0.140476 0.640573 0 0.979711 0 1.33333V38.6667C0 39.0203 0.140476 39.3594 0.390524 39.6095C0.640573 39.8595 0.979711 40 1.33333 40H38.6667C39.0203 40 39.3594 39.8595 39.6095 39.6095C39.8595 39.3594 40 39.0203 40 38.6667V1.33333C40 0.979711 39.8595 0.640573 39.6095 0.390524C39.3594 0.140476 39.0203 0 38.6667 0ZM37.3333 18.6667H21.3333V2.66667H37.3333V18.6667ZM18.6667 2.66667V18.6667H2.66667V2.66667H18.6667ZM2.66667 21.3333H18.6667V37.3333H2.66667V21.3333ZM21.3333 37.3333V21.3333H37.3333V37.3333H21.3333Z",
    fill: "#99439D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultGrid);
export default __webpack_public_path__ + "static/media/default-grid.1a3b4e3990d3c84eda4bffec424483c7.svg";
export { ForwardRef as ReactComponent };